import * as Sentry from '@sentry/react'
import { isHandledSessionError } from '@utils/handledSessionError'
import { isKnownNetworkFailureMessage } from '@utils/ignorableNetworkError'

const isProduction = process.env.REACT_APP_ENV === 'production'
const allowUrls = [/sentisis\.io/]

Sentry.init({
  dsn: 'https://5cb8ab4ff44242c3a56ec9a0e888b0df@app.getsentry.com/64804',
  allowUrls,
  release: process.env.VERSION,
  environment: process.env.REACT_APP_ENV,
  ignoreErrors: [
    "Cannot read property 'componentWillUnmount' of null",
    "Cannot read property 'remove' of undefined",
    "Cannot read property '_currentElement' of null",
    'Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.',
    'Unexpected identifier',
    'Unexpected token <',
    'captureException(raven-js/src/raven)',
    /failed to fetch/i,
    'Maximum update depth exceeded',
  ],
  enabled: isProduction,
  beforeSend(event, hint) {
    if (isHandledSessionError(hint?.originalException)) return null

    // Ignore if user was offline at the time of the error
    if (!navigator.onLine) return null

    const exceptionValues = event?.exception?.values || []
    const isIgnoredNetworkError = exceptionValues.some(exception => {
      const type = exception?.type || ''
      const value = exception?.value || ''

      return (
        type === 'AbortError' ||
        isKnownNetworkFailureMessage(value) ||
        value.includes('The user aborted a request') ||
        value.includes('signal is aborted without reason')
      )
    })

    const networkError = event?.extra?.networkError
    const networkErrorMessage =
      networkError && typeof networkError === 'object'
        ? `${(networkError as { message?: unknown }).message || ''}`
        : `${networkError || ''}`

    if (
      isIgnoredNetworkError ||
      isKnownNetworkFailureMessage(networkErrorMessage)
    ) {
      return null
    }

    return event
  },
})
